import { config } from '#config/configuration';
import { productFruits } from 'product-fruits';
import type { UserType } from '../user.query';

export const useProductFruits = (authenticatedUser: UserType) => {
  if (navigator.webdriver) {
    console.info('Product Fruits not enabled. Skipping ...');
    return;
  }
  if (!config.productFruitsWorkspace) {
    console.error('Product Fruits workspace id is not supplied. Skipping ...');
    return;
  }

  let productFruitsLang: string = authenticatedUser.appScope?.lang ?? 'en';
  if (productFruitsLang === 'fr-FR') {
    productFruitsLang = 'fr';
  }

  productFruits.init(config.productFruitsWorkspace, productFruitsLang, {
    email: authenticatedUser.email ?? '',
    username: authenticatedUser.email ?? ''
  });
};
